// import Vue from 'vue'
// import Vuex from 'vuex'

// Vue.use(Vuex)

import axios from 'axios'

const store = {
  state: {
    statuses: {},
    sseStatuses: {},
  },
  mutations: {
    setStatuses(state, data) {
      state.statuses = data
    },
    setSSE(state, data) {
      state.sseStatuses = data
    },
  },
  actions: {
    async getStatuses({ commit }) {
      const res = await axios.get('fetch').catch(err => {
        return err.response
      })
      if (res.status !== 200) {
        console.log('err')
      } else {
        console.log('success')
        commit('setStatuses', res.data)
      }
    },
  },
}

export default store

// export default new Vuex.Store({
//   state: {
//     statuses: {},
//     sseStatuses: {},
//   },
//   mutations: {
//     setStatuses(state, data) {
//       state.statuses = data
//     },
//     setSSE(state, data) {
//       state.sseStatuses = data
//     },
//   },
//   actions: {
//     async getStatuses({ commit }) {
//       const res = await axios.get('fetch').catch(err => {
//         return err.response
//       })
//       if (res.status !== 200) {
//         console.log('err')
//       } else {
//         commit('setStatuses', res.data)
//       }
//     },
//   },
// })
